module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title", [_vm._v("Adjunta una imagen o pdf")])], 2), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._t("topIcon", [_c('i', {
    staticClass: "fa fa-file-image-o"
  })])], 2)])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "upload-container w-64",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.uploadFile($event)
      }
    }
  }, [_c('p', {
    staticClass: "has-text-left"
  }, [_c('span', [_vm._t("explanation", [_vm._v("Adjunta una imagen o pdf")])], 2)]), (!_vm.filename) ? _c('div', {
    staticClass: "dropzone",
    attrs: {
      "id": "dropzone"
    },
    on: {
      "click": _vm.select
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.dropzone(_vm.name).active),
      expression: "$upload.dropzone(name).active"
    }],
    staticClass: "overlay"
  }, [_c('span', [_vm._v("Suelta el archivo para cargarlo")])])]), _vm._m(0), _c('span', {
    staticClass: "margin-bottom-10"
  }, [_vm._t("dropzoneDescription", [_vm._v("Arrastra el archivo o imagen que desees cargar o dale click al recuadro para buscar en tus archivos")])], 2)], 1) : _vm._e(), (_vm.$upload.errors(_vm.name).length > 0) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.$upload.errors(_vm.name)[0].msg))]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.filename) ? _c('div', {
    staticClass: "uploaded-file"
  }, [
    [_c('h5', {
      staticClass: "file-name mb-4 text-purple-500 font-bold"
    }, [_vm._v(_vm._s(_vm.filename))])], _c('div', {
      staticClass: "buttons-container"
    }, [
      [_c('button', {
        staticClass: "button flex-1 margin-left-5 is-primary",
        attrs: {
          "type": "submit"
        }
      }, [(_vm.isSaving) ? _c('i', {
        staticClass: "fa fa-spinner fa-spin"
      }) : [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fa fa-save fa-fw fa-lg"
      })]), _c('span', [_vm._v("Guardar archivo")])]], 2)]
    ], 2)
  ], 2) : _vm._e()])], 1)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6d94cf8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Upload_Image.vue
// module id = 860
// module chunks = 0